module.exports = __webpack_public_path__ + "img/customer-advance-standard.339f63f6.png";